import React from "react";
import {
  TextField,
  Grid,
  InputLabel,
  Select,
  MenuItem,
  DialogActions,
} from "@mui/material";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
// import { TextField } from '@mui/material';
import { useForm } from "react-hook-form";
import { useEffect, useState } from "react";
import axios from "axios";
import TableBody from "@mui/material/TableBody";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import { yupResolver } from "@hookform/resolvers/yup";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";

import { Dialog, DialogContent, Icon, Toolbar } from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import DialogTitle from "@mui/material/DialogTitle";
import CloseIcon from "@mui/icons-material/Close";
import { useNavigate, useLocation, Link } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import HomeIcon from "@mui/icons-material/Home";

// import { C8VALI } from "../../../Validation";
// import { FormControl } from "react-bootstrap";
import FormControl from "@mui/material/FormControl";
import { Box } from "react-bootstrap-icons";
import { dateFormat } from "../../../utils/Date";
import ComponentLoader from "../../../ComponentLoader";

function ArC15Inside({ head }) {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
  const [open, setOpen] = React.useState(false);

  const [Studentbtn, setStudentbtn] = useState([]);

  const [LovGrouptype, setLovGrouptype] = useState([]);
  const [fund, setFund] = useState([])

  const [OrganizationGrouptype, setOrganizationGrouptype] = useState("");
  const [OrganizationName, setOrganizationName] = useState("");
  const [Noofmembers, setNoofmembers] = useState("");
  const [Activities, setActivities] = useState("");

  const [OrganizationGrouptypeErr, setOrganizationGrouptypeErr] =
    useState(false);
  const [OrganizationNameErr, setOrganizationNameErr] = useState(false);
  const [NoofmembersErr, setNoofmembersErr] = useState(false);
  const [ActivitiesErr, setActivitiesErr] = useState(false);

  const [state, setState] = useState();
  const [assM, setAssMonth] = useState("");
  const [invis, setInvestigator] = useState();
  const [insti, setInsti] = useState();

  const [loader,setLoader] =useState(true)
  const [token, setToken] = useState("");
  const [id, setId] = useState(0);
  const [inves, setInves] = useState([])
  const [InvestigatorName, setInvestigatorName] = useState("")
  const [InvestigatorNameErr, setInvestigatorNameErr] = useState(false)
  console.log(InvestigatorName)
  const [value, setValue] = useState({
    ProjectTitle: "",
    FundingAgencyId: "",
    DateOfClosure: "",
    SubmissionReport: "",
    SettlementOfAccounts: "",

  });

  const [errValue, setErrValue] = useState({
    ProjectTitle: false,
    FundingAgencyId: false,
    DateOfClosure: false,
    SubmissionReport: false,
    SettlementOfAccounts: false,

  });

  const navigate = useNavigate();
  const location = useLocation();

  const toastSuccess = (data) => {
    toast.success(data, {
      position: toast.POSITION.TOP_RIGHT,
    });
  };

  const {
    register,
    handleSubmit,
    formState: { errors, isValid },
    // setValue,
    reset,
    watch,
  } = useForm({
    // resolver: yupResolver(C8VALI),
  });

  const backs = () => {
    navigate("/ArC15");
  };

  useEffect(() => {
    const tok = localStorage.getItem("token");
    setToken(tok);
    console.log(tok);
    if (tok != null && tok != undefined) {
      handleFund(tok);
      console.log(location.state);
      if (location.state) {
        edit(location.state);
      }
    }
    head(" SHG created");
  }, []);

  useEffect(() => {
    const objectString = localStorage.getItem("MReport");
    const tok = localStorage.getItem("token");
    const myObject = JSON.parse(objectString);
    if (myObject !== null) {
      setState(myObject);
    }
    const Month = localStorage.getItem("Month");
    if (Month !== null) {
      setAssMonth(Month);
    }
    const insti = localStorage.getItem("loginId");
    setInsti(insti);
    handleInvestigators(tok, insti)
  }, []);

  const edit = (item) => {
    console.log(item);
    //     projectTitle
    // fundingAgencyName
    // dateOfClosure
    // submissionReport
    // settlementOfAccounts
    setValue({
      ProjectTitle: item.projectTitle,
      FundingAgencyId: item.fundingAgencyId,
      DateOfClosure: dateFormat(item.dateOfClosure),
      SubmissionReport: item.submissionReport,
      SettlementOfAccounts: item.settlementOfAccounts,
    })
    setInvestigatorName(item.investigatorId);
    setId(item.id);
  };

  const handleData = ((event) => {
    const { name, value } = event.target
    setValue(prev => ({
      ...prev,
      [name]: value
    }))
  })

  console.log("value", value);

  const handleClickOpen = () => {
    setOpen(true);
    //  navigate("/Activities")
  };

  const handleClose = () => {
    setOpen(false);
    // setId(0)
  };

  // Lov Group Type
  const handleFund = async (token) => {
    console.log(token);

    const h = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    };
    try {
      const { data } = await axios.get(
        `${window.BASE}${window.FUNDINGGETALL}`,
        {
          headers: h,
        }
      );
      console.log(data);setLoader(false)
      setFund(data);
    } catch (error) {
      console.log(error);setLoader(false)
    }
  };
  const handleInvestigators = async (token, id) => {
    const h = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    };
    try {
      const { data } = await axios.get(`${window.BASE}${window.INVESTIGATORIDMAPNAME}${id}`, {
        headers: h,
      });
      console.log(data);
      setInves(data);setLoader(false)
    } catch (error) {
      console.log(error);setLoader(false)
    }
  };
  const handleLeavepage = async () => {
    const h = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    };
    console.log(token);

    const d = {
      id,
      InvestigatorId: InvestigatorName,
      ProjectTitle: value.ProjectTitle,
      FundingAgencyId: value.FundingAgencyId,
      DateOfClosure: value.DateOfClosure,
      SubmissionReport: value.SubmissionReport,
      SettlementOfAccounts: value.SettlementOfAccounts,
      IAMRSId: state.id,
      InstituteId: parseInt(insti),
      RptMonth: parseInt(assM),
    };
    if (id === 0) {
      try {
        const { data } = await axios.post(`${window.BASE}${window.ARC15SAVE}`, d, {
          headers: h,
        });
        console.log(data);
        setStudentbtn(data);

        if (data.result === "Success") {
          alert("Succesfully Submitted");
          navigate("/ArC15");
          toastSuccess("Successfully Submitted");
          setId(0);
          setOpen(false);
        } else {
          // toastError(data.errorMsgs)
        }
        //   setDirect(data);
      } catch (error) {
        console.log(error);
      }
    } else {
      try {
        const { data } = await axios.post(`${window.BASE}${window.ARC15EDIT}`, d, {
          headers: h,
        });
        console.log(data);

        if (data.result === "Success") {
          alert("Succesfully Submitted");
          navigate("/ArC15");
          toastSuccess("Successfully updated");
          setId(0);
          setOpen(false);
        }
      } catch (error) {
        console.log(error);
      }
    }
  };

  const formValidateFun = () => {
    if(!InvestigatorName){
      setInvestigatorNameErr(true)
      document.getElementById("InvestigatorName").focus()}


   else if (!value.ProjectTitle) {
      setErrValue((prev) => ({ ...prev, ProjectTitle: true }))
      document.getElementById("ProjectTitle").focus()
    } else if (!value.FundingAgencyId) {
      setErrValue((prev) => ({ ...prev, FundingAgencyId: true }))
      document.getElementById("FundingAgencyId").focus()
    } else if (!value.DateOfClosure) {
      setErrValue((prev) => ({ ...prev, DateOfClosure: true }))
      document.getElementById("DateOfClosure").focus()
    }
    else if (!value.SubmissionReport) {
      setErrValue((prev) => ({ ...prev, SubmissionReport: true }))
      document.getElementById("SubmissionReport").focus()
    }
    else if (!value.SettlementOfAccounts) {
      setErrValue((prev) => ({ ...prev, SettlementOfAccounts: true }))
      document.getElementById("SettlementOfAccounts").focus()
    }
    else {
      handleLeavepage()
    }

  };

  return (
    <div className="main-container-margin">
       <ComponentLoader isLoading={loader} />
      <div className="master-main d-flex">
        <div className="head-icon">
          <Link to="/GeneralAR">
            <HomeIcon style={{ color: "white", marginLeft: 70 }} />
          </Link>
        </div>
        <div className="master-main-span">
          <span>C15. Project Closure</span>
        </div>
      </div>

      <div className="from-mains">
        <div className="form-control">
          <h5 style={{ margin: 20 }}>
            C15. Project Closure
          </h5>


          <FormControl style={{ width: "48%", margin: 12 }} error={InvestigatorNameErr} id="InvestigatorName">
            <InputLabel id="demo-simple-select-helper-label" size="small">
              Faculty Name
            </InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="investigatorName"
              value={InvestigatorName}
              label="Programme Type"
              size="small"
              sx={{ width: "100%" }}
              onChange={(e) => {
                setInvestigatorName(e.target.value)
                setInvestigatorNameErr(false)
              }}
            >
              {inves?.map((row, index) => {
                return (
                  <MenuItem key={row.index} value={row.id}>
                    {row.investigatorName}
                  </MenuItem>
                );
              })}
            </Select>
          </FormControl>


          <TextField

            id="ProjectTitle"
            label="Title of the Project"
            variant="outlined"
            style={{ margin: "10px", width: "48%" }}
            name="ProjectTitle"
            error={errValue.ProjectTitle}
            value={value.ProjectTitle}
            onChange={(e) => {
              handleData(e);
              setErrValue((prev) => ({ ...prev, ProjectTitle: false }));
            }}
          />

          {/* <TextField
           
            id="FundingAgencyId"
            label="Funding
            Agency
            "
            variant="outlined"
            style={{ margin: "10px", width: "48%" }}
            name="FundingAgencyId"
            error={errValue.FundingAgencyId}
            value={value.FundingAgencyId}
            onChange={(e) => {
              handleData(e);
              setErrValue((prev) => ({ ...prev, FundingAgencyId: false }));
            }}
          /> */}


          <FormControl
            style={{ width: "45%", margin: 12 }}
            // error={facultyErr}
            id="FundingAgencyId"
            size="small"
          >
            <InputLabel id="demo-simple-select-helper-label" size="small">
              Funding
              Agency                        </InputLabel>
            <Select
              variant="outlined"
              size="small"
              name="FundingAgencyId"
              error={errValue.FundingAgencyId}
              style={{ height: "45px" }}

              value={value.FundingAgencyId}
              onChange={(e) => {
                handleData(e);
                setErrValue((prev) => ({ ...prev, FundingAgencyId: false }));
              }}
            >
              {fund?.map((option, index) => {
                return (
                  <MenuItem key={index} value={option.id}>
                    {option.fundingAgencyName}
                  </MenuItem>
                );
              })}
            </Select>
          </FormControl>

          <TextField

            id="DateOfClosure"
            label="Date of
            closure
            "
            type="date"
            variant="outlined"
            style={{ margin: "10px", width: "48%" }}
            name="DateOfClosure"
            InputLabelProps={{
              shrink: true
            }}
            inputProps={{
              placeholder: "",
            }}
            error={errValue.DateOfClosure}
            value={value.DateOfClosure}
            onChange={(e) => {
              handleData(e);
              setErrValue((prev) => ({ ...prev, DateOfClosure: false }));
            }}
          />

          <TextField

            id="SubmissionReport"
            label="Submission of completion
            report            
            "
            variant="outlined"
            style={{ margin: "10px", width: "48%" }}
            name="SubmissionReport"
            error={errValue.SubmissionReport}
            value={value.SubmissionReport}
            onChange={(e) => {
              handleData(e);
              setErrValue((prev) => ({ ...prev, SubmissionReport: false }));
            }}
          />
          <TextField

            id="SettlementOfAccounts"
            label="Settlement of accounts           
            "
            variant="outlined"
            style={{ margin: "10px", width: "48%" }}
            name="SettlementOfAccounts"
            error={errValue.SettlementOfAccounts}
            value={value.SettlementOfAccounts}
            onChange={(e) => {
              handleData(e);
              setErrValue((prev) => ({ ...prev, SettlementOfAccounts: false }));
            }}
          />

          <div className="from-last">
            <button
              type="submit"
              style={{
                backgroundColor: "#008CBA",
                height: "20px",
                padding: "5px 30px 28px 26px",
                borderRadius: "3px",
                color: "#fff",
              }}
              onClick={backs}
            >
              Back
            </button>
            <button
              type="submit"
              className="sbmit-buttons"
              onClick={() => formValidateFun()}
              style={{ paddingTop: "5px" }}
            >
              Save
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ArC15Inside;